// Copyright (c) 2019 Deere & Company

const defaultLoadingState = 0;

export const showLoadingIndicator = (applicationState) => applicationState > defaultLoadingState;
